import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { loginPageText, UserManagementActions } from '../../services/enums';
import { ToastMessageOptions, MessageService } from 'primeng/api';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';
import { PrimecustomModule } from 'src/app/shared/primeng.custom.module';
import { SsoService } from '../../services/sso.service';
import { RESET_PASSWORD_API_URL } from 'src/app/shared/api.constant';
import { UtilService } from '../../services/util.service';
@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    MessageModule,
    ReactiveFormsModule,
    PrimecustomModule,
  ],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  ngUnsubscribe: Subject<any> = new Subject<any>();
  actions = UserManagementActions;
  mode: string;
  actionCode: string;
  newPassword: string;
  confirmPassword: string;

  actionCodeChecked: boolean;
  loading = false;
  passwordForm!: FormGroup;
  messages!: ToastMessageOptions[];
  svgPath: any = 'assets/img/common/';
  TextEnum = loginPageText;
  isExpired = false;
  closable = true;
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly fb: FormBuilder,
    private readonly messageService: MessageService,
    private readonly sso: SsoService,
    private readonly utils: UtilService
  ) {
    this.mode = '';
    this.actionCode = '';
    this.newPassword = '';
    this.confirmPassword = '';
    this.actionCodeChecked = false;

    this.passwordForm = this.fb.group({
      newPassword: ['', [Validators.required]],
      confirmPassword: [''],
      showPassword: [false],
    });

    // Add custom validator to compare passwords
    this.passwordForm
      .get('confirmPassword')
      ?.setValidators([Validators.required, this.passwordMatchValidator()]);
    this.passwordForm.get('newPassword')?.valueChanges.subscribe((value) => {
      this.passwordForm.get('confirmPassword')?.updateValueAndValidity();
    });
  }

  passwordMatchValidator() {
    return (control: any) => {
      const confirmPassword = control.value;
      const newPassword = this.passwordForm.get('newPassword')?.value;

      if (confirmPassword === newPassword) {
        return null; // Passwords match
      } else {
        return { mismatch: true }; // Passwords do not match
      }
    };
  }

  success(message: string, life: number) {
    this.messageService.add({
      severity: 'success',
      summary: message,
      life: life,
    });
  }

  warn(message: string, life: number) {
    this.messageService.add({
      severity: 'warn',
      summary: message,
      life: life,
    });
  }

  get showPassword() {
    return this.passwordForm.get('showPassword');
  }

  ngOnInit() {
    this.closable = true;
    this.isExpired = false;
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params) => {
        if (!params) this.utils.redirectToLogin();
        this.mode = params['mode'];
        this.actionCode = params['oobCode'];
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  handleResetPassword() {
    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched();
      return;
    }

    this.loading = true;

    const body = {
      oobCode: this.actionCode,
      newPassword: this.passwordForm.get('confirmPassword')?.value,
    };

    this.sso.post(RESET_PASSWORD_API_URL, body).subscribe({
      next: (response) => {
        this.loading = false;
        if (response.status) {
          this.success(response?.data?.message, 2000);
          setTimeout(() => {
            this.utils.redirectToLogin();
          }, 2000);
        } else {
          this.warn(response?.data?.message, 2000);
        }
      },
      error: (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'warn', summary: error });
      },
    });
  }
}
